import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  if (user && user.role === "admin") {
    return <Navigate to="/admin" replace />;
  }

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    const res = await login(email, password);
    setSubmitting(false);
    if (res.ok) {
      toast.success("Welcome back.");
      navigate("/admin");
    } else {
      setError(res.error || "Login failed");
    }
  };

  return (
    <div className="min-h-[75vh] flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md fade-up">
        <p className="plaque-label">Curator Access</p>
        <h1 className="font-serif-display font-light text-5xl leading-none mt-3">Sign in</h1>
        <form onSubmit={submit} className="mt-12 space-y-6" data-testid="login-form">
          <div>
            <label className="plaque-label">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="line-input"
              placeholder="admin@gallery.com"
              data-testid="login-email-input"
              required
            />
          </div>
          <div>
            <label className="plaque-label">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="line-input"
              placeholder="••••••••"
              data-testid="login-password-input"
              required
            />
          </div>
          {error && (
            <p className="text-sm text-red-400" data-testid="login-error-message">
              {error}
            </p>
          )}
          <button
            type="submit"
            disabled={submitting}
            className="w-full text-xs tracking-[0.3em] uppercase border border-[#D4AF37]/40 hover:border-[#D4AF37] px-6 py-4 text-[#D4AF37] transition-colors disabled:opacity-50"
            data-testid="login-submit-button"
          >
            {submitting ? "Signing in…" : "Enter Gallery"}
          </button>
        </form>
      </div>
    </div>
  );
}
